import { Blocs } from '@business/blocs';
import { GmailMessageId } from '@business/entities/gmail_messages';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { forkJoin } from 'rxjs';
export class EmailOverlayBloc extends BaseBloc {
  private readonly activityBloc = resolve(Blocs.contactActivity);
  private readonly emailBloc = resolve(Blocs.email);

  constructor(private readonly messageId: GmailMessageId) {
    super();
  }

  email$ = this.emailBloc.selectItem(this.messageId);

  loading = new LoadingState();

  onInit() {
    return forkJoin([this.emailBloc.fetchEmail(this.messageId)]).pipe(this.loading.run());
  }
}
